import { z } from "zod";
import { ComponentRoleSchema } from "./component-role.js";
import { ComponentSelectionSchema } from "./component-selection.js";
import { CertificationLifecycleStatusSchema } from "./strategy.js";
export const LensQualityFloorSchema = z
    .object({
    requiredRoles: z.array(ComponentRoleSchema).default([]),
    allowedFallbacks: z.array(z.string().min(1)).default([]),
    mobileFixtureId: z.string().min(1).optional(),
    requiresPrimaryCta: z.boolean().default(true),
    requiresProofSafety: z.boolean().default(true),
})
    .strict();
export const StyleLibrarySchema = z
    .object({
    styleLibraryId: z.string().min(1),
    version: z.string().min(1),
    tokenProfile: z.string().min(1),
    supportedSurfacePacks: z.array(z.string().min(1)).default([]),
    status: z.enum(["DRAFT", "ACTIVE", "DEPRECATED"]).default("ACTIVE"),
    certificationStatus: CertificationLifecycleStatusSchema.default("candidate"),
    visualTokens: z.record(z.string().min(1)).default({}),
})
    .strict();
export const LensSchema = z
    .object({
    lensId: z.string().min(1),
    lensVersion: z.string().min(1),
    styleLibraryId: z.string().min(1),
    supportedRoles: z.array(ComponentRoleSchema).default([]),
    allowedComponents: z.array(z.string().min(1)).default([]),
    certificationStatus: CertificationLifecycleStatusSchema.default("candidate"),
    qualityFloor: LensQualityFloorSchema,
    mobileExpectations: z.array(z.string().min(1)).default([]),
    visualTokens: z.record(z.string().min(1)).default({}),
    typographyRhythm: z.string().min(1).optional(),
    spacingRhythm: z.string().min(1).optional(),
    densityRules: z.array(z.string().min(1)).default([]),
    motionRules: z.array(z.string().min(1)).default([]),
    mobileRules: z.array(z.string().min(1)).default([]),
    unsupportedRoles: z.array(ComponentRoleSchema).default([]),
    contactSheetExpectations: z.array(z.string().min(1)).default([]),
    proofBehavior: z.string().min(1),
    ctaBehavior: z.string().min(1),
})
    .strict();
export const ReferenceCompositionSchema = z
    .object({
    referenceId: z.string().min(1),
    sectionOrder: z.array(ComponentRoleSchema),
    componentSelections: z.array(ComponentSelectionSchema),
    density: z.enum(["compact", "standard", "spacious"]).default("standard"),
    mobileFixture: z.string().min(1).optional(),
    ctaVariant: z.string().min(1).optional(),
    proofLayout: z.string().min(1).optional(),
})
    .strict();
export const LensReferenceSchema = z
    .object({
    referenceId: z.string().min(1),
    lensId: z.string().min(1),
    artifactSetHash: z.string().min(1),
    buildManifestRef: z.string().min(1),
    qualityGateResultRef: z.string().min(1),
    generatedAt: z.string().datetime(),
    sourceGraphHash: z.string().min(1),
    composition: ReferenceCompositionSchema,
})
    .strict();
export const CompositionLockSchema = z
    .object({
    lockId: z.string().min(1),
    lensId: z.string().min(1),
    recipeId: z.string().min(1),
    componentSelections: z.array(ComponentSelectionSchema),
    sectionOrder: z.array(ComponentRoleSchema),
    density: z.enum(["compact", "standard", "spacious"]).default("standard"),
    mobileFixture: z.string().min(1).optional(),
    lockedBy: z.string().min(1),
    lockedAt: z.string().datetime(),
})
    .strict();
//# sourceMappingURL=lens.js.map